import React, { useState, useEffect } from "react";
import "./App.css";
// import resume from "./resume";
import { Basics } from "./components/Basics";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Experience } from "./components/Experience";
import { Education } from "./components/Education";
import { Projects } from "./components/Projects";
import { Publications } from "./components/Publications";
import Soical from "./components/Social";
import Form from "./components/Form";
import resumeURL from "./resumeURL";
import "./index.css";

import { Col, Container, Row } from "react-bootstrap";

function App() {
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [resume, setResume] = useState(null);

  useEffect(() => {
    fetch(resumeURL)
      .then((res) => res.json())
      .then((res) => {
        debugger;
        setResume(res);
      });
  }, []);
  return (
    resume && (
      <div className="App">
        <Container className="container">
          <Row>
            <Col>
              <Basics {...resume.basics} />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <About {...resume.about} />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <Experience work={resume.work} />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <Education {...resume.education[0]} />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <Publications publications={resume.publications} />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
              <Projects projects={resume.projects} />
            </Col>
          </Row>
          <Row id="contact">
            <Form isVisible={true} />
          </Row>
        </Container>
      </div>
    )
  );
}

export default App;
